<script>
  import { getCartCount } from '../../../../../js/stores';

  // Sane defaults, but should be localized in dataJSON
  export let title = 'Your cart';
  export let statusZero = '{count} items';
  export let statusOne = '{count} item';
  export let statusMany = '{count} items';

  const countStore = getCartCount();

  $: message = getStatus($countStore);

  function getStatus(count) {
    switch (count) {
      case 0: {
        return statusZero.replace(/{count}/, count);
      }
      case 1: {
        return statusOne.replace(/{count}/, count);
      }
      default: {
        return statusMany.replace(/{count}/, count);
      }
    }
  }
</script>

<div class="Status">
  <div class="title">{title}</div>
  <div class="message">{message}</div>
</div>

<style>@charset "UTF-8";
.Status {
  box-sizing: border-box;
  position: relative;
  padding: 30px;
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  color: var(--color-text, #1a1a1a);
}

.title {
  margin-bottom: 20px;
  font-weight: var(--font-weight-medium, 500);
  text-align: left;
}

.message {
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
  text-align: center;
}</style>
